"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMoneyCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zM12.318 4a.75.75 0 01.743.648l.007.102V6a3.296 3.296 0 012.523 3.205.75.75 0 11-1.5 0c0-.715-.417-1.332-1.022-1.621v3.506a3.296 3.296 0 010 6.41v1.25a.75.75 0 01-1.494.102l-.007-.102v-1.24A3.297 3.297 0 019 14.295a.75.75 0 011.5 0c0 .734.439 1.364 1.068 1.643V12.42a3.296 3.296 0 010-6.43V4.75a.75.75 0 01.75-.75zm.751 8.673v3.243a1.797 1.797 0 000-3.243zm-1.501-5.11a1.795 1.795 0 000 3.284V7.562z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgMoneyCircle;
exports.default = _default;